import { render, staticRenderFns } from "./add-update-resource-action.vue?vue&type=template&id=23758b58&scoped=true&"
import script from "./add-update-resource-action.vue?vue&type=script&lang=js&"
export * from "./add-update-resource-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23758b58",
  null
  
)

export default component.exports